import { useContext } from 'react';
import { SwitchTestContextSsr } from '../components/SwitchTestProviderSsr/SwitchTestProviderSSR';

const useSwitchesFromContext = () => {
  const {
    switches,
  } = useContext(SwitchTestContextSsr);

  const getSwitchValue = (key) => switches?.[key];

  return { switches, getSwitchValue };
};

export default useSwitchesFromContext;
